<template>
  <div class="container mt-4">
    <div class="row">
      <!-- Panel de gestión de grupos -->
      <div class="col-md-4">
        <h4 class="mb-3 text-center">Gestión de Grupos</h4>
        <input type="text" class="form-control mb-3" v-model="searchTerm" placeholder="Buscar grupo..." />

        <ul class="list-group">
          <li v-for="grupo in gruposPaginados" :key="grupo.id"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            :class="{ active: grupo.id === grupoActual?.id }" @click="selectGrupo(grupo)">
            {{ grupo.nombre }}
            <span class="badge bg-info">{{ grupo.etiquetas.length }} etiquetas</span>
          </li>
        </ul>

        <!-- Controles de paginación -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button class="btn btn-secondary" @click="prevPage" :disabled="currentPage === 1">Anterior</button>
          <span>Página {{ currentPage }} de {{ totalPages }}</span>
          <button class="btn btn-secondary" @click="nextPage" :disabled="currentPage === totalPages">Siguiente</button>
        </div>
      </div>

      <!-- Tarjeta de cumplimiento -->
      <div class="col-md-8">
        <div v-if="grupoActual" class="card shadow-sm">
          <div class="card-header d-flex justify-content-between align-items-center"
            :style="{ backgroundColor: grupoActual.color || 'var(--app-primary)', color: '#fff' }">
            <h5 class="mb-0">{{ grupoActual.nombre }}</h5>
            <div>
              <button class="btn btn-sm btn-success me-2" @click="mostrarNuevoCumplimiento()">Nueva Etiqueta</button>
              <button class="btn btn-sm btn-secondary me-2" @click="editarGrupo(grupoActual.id)">Editar Grupo</button>
              <button class="btn btn-sm btn-danger me-2" @click="eliminarGrupo(grupoActual.id)">Eliminar Grupo</button>
            </div>
          </div>
          <div class="card-body">
            <ul class="list-group list-group-flush">
              <li v-for="etiqueta in grupoActual.etiquetas" :key="etiqueta.id" class="list-group-item">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ etiqueta.precedencia }}) {{ etiqueta.nombre }}</strong>
                    <span class="badge bg-secondary">{{ etiqueta.tipo }}</span>
                    <div class="etiqueta-info mt-2">
                      <div><strong>Descripción:</strong> {{ etiqueta.descripcion }}</div>
                      <div><strong>Es Obligatoria:</strong> {{ etiqueta.es_obligatoria ? 'Sí' : 'No' }}</div>
                      <div v-if="etiqueta.fecha_inicio"><strong>Inicio:</strong> {{ formatFecha(etiqueta.fecha_inicio)
                      }}</div>
                      <div v-if="etiqueta.fecha_fin"><strong>Fin:</strong> {{ formatFecha(etiqueta.fecha_fin) }}</div>
                    </div>
                  </div>
                  <button class="btn btn-sm btn-danger" @click="eliminarEtiqueta(etiqueta.id)">Eliminar</button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="text-muted">Seleccione un grupo para ver sus etiquetas.</div>



      </div>
    </div>




    <!-- Modal de Vue 3 para nueva etiqueta -->
    <teleport to="body">
      <transition name="modal-fade">
        <div v-if="mostrarFormNuevoCumplimiento && grupoActual" class="modal-mask"
          @click.self="cerrarModalNuevoCumplimiento">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Nueva Etiqueta</h5>
                <button class="close-button" @click="cerrarModalNuevoCumplimiento">×</button>
              </div>
              <div class="modal-body">
                  <vincular-cumplimiento-a-grupo :grupo_id="grupoActual.id" :maxPrecedencia="calcularMaxPrecedencia()" @cumplimientoCreado="cumplimientoCreado" @cancelar="cerrarModalNuevoCumplimiento"/>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>


    <!-- Modal de Edición de Grupo -->
    <teleport to="body">
      <transition name="modal-fade">
        <div v-if="vistaActiva === 'editar' && grupoEnEdicion" class="modal-mask" @click.self="volverAlListado">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Editar Grupo</h5>
                <button class="close-button" @click="volverAlListado">×</button>
              </div>
              <div class="modal-body">
                <editar-grupo :grupo-id="grupoEnEdicion.id" @volver="volverAlListado" />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>


  </div>





</template>

<script>
import axios from '@/axios';
import VincularCumplimientoAGrupo from './vincularCumplimientoAGrupo.vue';
import EditarGrupo from './alta-editar-grupo.vue'


export default {
  data() {
    return {
      grupos: [],
      searchTerm: '',
      currentIndex: 0,
      mostrarFormNuevoCumplimiento: false,
      currentPage: 1,
      itemsPerPage: 5,
      clubActual: null,
      vistaActiva: 'listado', // 👈 'listado' o 'editar'
      grupoEnEdicion: null     // 👈 grupo que se está editando
    };
  },
  components: {
    VincularCumplimientoAGrupo,
    EditarGrupo
  },
  watch: {
    mostrarFormNuevoCumplimiento(nuevo) {
      document.body.style.overflow = nuevo ? 'hidden' : '';
    }
  },
  computed: {
    gruposFiltrados() {
      const searchTermLower = this.searchTerm.toLowerCase();
      return this.grupos.filter((grupo) => grupo.nombre.toLowerCase().includes(searchTermLower));
    },
    totalPages() {
      return Math.ceil(this.gruposFiltrados.length / this.itemsPerPage);
    },
    gruposPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.gruposFiltrados.slice(start, start + this.itemsPerPage);
    },
    grupoActual() {
      return this.gruposPaginados[this.currentIndex] || null;
    },
  },
  methods: {
    async cargarGruposConCumplimientos() {
      try {
        const response = await axios.get('/api/cumplimiento/grupos-con-cumplimientos', {
          params: { club_id: this.clubActual.id },
        });
        this.grupos = response.data;
      } catch (error) {
        console.error('Error al cargar los grupos:', error);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.currentIndex = 0;
        this.ocultarNuevoCumplimiento();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.currentIndex = 0;
        this.ocultarNuevoCumplimiento();
      }
    },
    selectGrupo(grupo) {
      this.currentIndex = this.gruposPaginados.findIndex((g) => g.id === grupo.id);
      this.ocultarNuevoCumplimiento();
    },

    ocultarNuevoCumplimiento() {
      this.mostrarFormNuevoCumplimiento = false;
    },
    async eliminarGrupo(grupoId) {
      if (confirm('¿Estás seguro de eliminar este grupo?')) {
        try {
          await axios.delete(`/api/cumplimiento/grupos/${grupoId}`, { data: { club_id: this.clubActual.id } });
          this.grupos = this.grupos.filter((grupo) => grupo.id !== grupoId);
          this.currentPage = 1;
        } catch (error) {
          alert('Error al eliminar el grupo '+error.response.data.error);
          console.error('Error al eliminar el grupo:', error);
        }
      }
    },
    async editarGrupo(grupoId) {
      const grupo = this.grupos.find(g => g.id === grupoId);
      if (grupo) {
        this.grupoEnEdicion = grupo;
        this.vistaActiva = 'editar';
      }
    },
    volverAlListado() {
      this.vistaActiva = 'listado';
      this.grupoEnEdicion = null;
      this.cargarGruposConCumplimientos(); // Opcional, para refrescar lista
    },

    async eliminarEtiqueta(etiquetaId) {
      if (confirm('¿Estás seguro de eliminar esta etiqueta?')) {
        try {
          await axios.delete(`/api/cumplimiento/etiquetas/${etiquetaId}`);
          this.grupoActual.etiquetas = this.grupoActual.etiquetas.filter((etiqueta) => etiqueta.id !== etiquetaId);
        } catch (error) {
          console.error('Error al eliminar la etiqueta:', error);
        }
      }
    },
    formatFecha(fecha) {
      return new Date(fecha).toLocaleDateString();
    },
    mostrarNuevoCumplimiento() {
      if (!this.grupoActual) return;
      this.mostrarFormNuevoCumplimiento = true;
    },
    cerrarModalNuevoCumplimiento() {

      this.mostrarFormNuevoCumplimiento = false;
    },
    calcularMaxPrecedencia() {
      if (!this.grupoActual || !this.grupoActual.etiquetas) return 1;
      const maxPrecedencia = Math.max(...this.grupoActual.etiquetas.map(etiqueta => etiqueta.precedencia || 0));
      return maxPrecedencia === -Infinity ? 0 : maxPrecedencia;
    },
    cumplimientoCreado(nuevoCumplimiento) {
      this.$emit('cumplimientoCreado', nuevoCumplimiento);
      this.grupoActual.etiquetas.push(nuevoCumplimiento);
      this.cerrarModalNuevoCumplimiento();
    },
  },
  mounted() {
    this.clubActual = this.$store.getters.getClubActual;
    this.cargarGruposConCumplimientos();
  },
};
</script>

<style scoped>
.container {
  max-width: 1100px;
}

.card {
  border-radius: 8px;
}

.card-header {
  font-weight: bold;
  font-size: 1.25rem;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item.active {
  background-color: var(--app-primary);
  color: white;
}

.etiqueta-info {
  font-size: 0.9rem;
}

.btn {
  margin-top: 1rem;
}

.modal-mask {
  position: fixed;
  z-index: 1050;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-wrapper {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  max-height: 90vh;
  /* evita desbordar la pantalla */
  display: flex;
  flex-direction: column;
}

.modal-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
  max-height: 70vh;
  /* altura máxima del contenido scrollable */
}


.modal-header {
  background-color: var(--app-primary);
  color: white;
  padding: 1rem;
}


/* Transición suave */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.close-button {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
}
</style>
